import { Component, OnInit } from '@angular/core';
import {
  faBinoculars,
  faChartMixed, faChevronDown, faClipboard,
  faGauge,
  faListCheck,
  faPeople,
  faPeopleGroup
} from "@fortawesome/pro-light-svg-icons";

@Component({
  selector: 'app-individual-menu',
  templateUrl: './individual-menu.component.html',
  styleUrls: ['./individual-menu.component.scss']
})
export class IndividualMenuComponent implements OnInit {

  faPeopleGroup = faPeopleGroup;
  faListCheck = faListCheck;
  faPeople = faPeople;
  faBinoculars = faBinoculars;
  faGauge = faGauge;
  faChartMixed = faChartMixed;
  faChevronDown = faChevronDown;

  isCollapsed = false;

  constructor() { }

  ngOnInit(): void {
  }

}
